import React from 'react';
import { Grid } from '@mui/material';
import {
	Create,
	DateTimeInput,
	SelectInput,
	SimpleForm,
	TextInput,
} from 'react-admin';

const reasonChoices = [
	{ id: 'promo', name: 'Promo' },
	{ id: 'admin', name: 'Admin' },
	{ id: 'migration', name: 'Migration' },
];

export const OverrideCreate = (props: any) => {
	return (
		<Create {...props}>
			<SimpleForm>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<TextInput source="billingAccountId" label="Billing Account ID" required />
						<TextInput source="featureId" label="Feature ID" required />
						<TextInput source="value" required />
						<SelectInput source="reason" choices={reasonChoices} required />
						<DateTimeInput source="expiresAt" label="Expires At (optional)" />
					</Grid>
				</Grid>
			</SimpleForm>
		</Create>
	);
};
